<template>
  <div class="layout-box">
    <LayoutHeader headtitle="景气指数"></LayoutHeader>
    <div class="secondary-content">
      <div class="matching-l">
        <div class="shell">
          <h3 style="padding-top: 12px">综合负荷</h3>
          <div id="machartbar" style="height: 256px; width: 100%; margin-top: 10px"></div>
          <h3 style="margin-top: 40px">综合价格</h3>
          <div id="machartline" style="height: 256px; width: 100%"></div>
        </div>
      </div>
      <div class="matching-c clear">
        <div class="matching-c-l">
          <h3>化纤行业景气指数</h3>
          <div id="machartbar3" style="height: 566px; width: 100%; margin-top: 10px"></div>
        </div>
        <div class="matching-c-r">
          <div class="matching-c-r-t">
            <div class="month-prosperity">
              <div :class="matchingdata.percentage<0?'fall':''"><h3>本月景气指数</h3><p><span><b>{{ parseFloat(matchingdata.monthAvg||0).toFixed(1) }}</b></span><span><i style="margin-top: 6px">{{ parseFloat(matchingdata.loseAvg||0).toFixed(1) }}</i><i>{{ parseFloat((matchingdata.percentage||0).toFixed(2)) }}%</i></span></p></div>
            </div>
          </div>
          <h3 style="margin-top: 12px; line-height: 180%">相关文章</h3>
          <div class="matching-c-r-b">
            <div class="first-news" v-if="newslist[0]">
              <el-image  style="width: 150px; height: 104px"  :src="newslist[0].imageurl||imgurl" fit="contain"></el-image>
              <span>
                <a :href="'/newdetail?id='+newslist[0].id" :title="newslist[0].title" target="_blank">{{ newslist[0].title }}</a><i class="iconfont icon-VIP" v-if="newslist[0].fee!=0"></i>
                <p>{{ newslist[0].content | toText }}</p>
              </span>
            </div>
            <ul v-if="newslist.length>1">
              <li v-for="(item,index) in newslist.slice(1,5)" :key="index"><i>◈</i><p><a :href="'/newdetail?id='+item.id" :title="item.title" target="_blank">{{ item.title }}</a><i class="iconfont icon-VIP" v-if="item.fee!=0"></i></p><span>{{ item.createtime | parseTimes }}</span></li>
            </ul>
<!--            <div class="no-data"><p><i class="iconfont icon-queshengye_zanwushuju"></i></p>{{}}</div>-->
            <el-empty :description="newslist.length>0?'没有更多文章':'没有相关文章'" :image-size="70" :style="newslist.length>0?'padding: 0':''" v-else></el-empty>
          </div>
        </div>
      </div>
      <div class="matching-r">
        <div class="shell">
          <h3>宏观指数</h3>
          <div id="machartbar2" style="height: 256px; width: 100%; margin-top: 10px"></div>
          <h3 style="margin-top: 40px">江浙加弹开工率</h3>
          <div id="machartline2" style="height: 256px; width: 100%"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import {parseTime} from "../../bll/utils"
export default {
  name: 'Index-prosperity',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader
  },
  filters: {
    toText(vals) {
      let text =vals||''
      return text.toString().replace(/<[^<>]+>/g,'').replace(/\s*/g,"").replace(/(&nbsp;)/g,'').replace(/&([^&;]+);/g, function (matchStr, b) {
        var entity = {
          nbsp: ' ',
          quot: '"',
          lt: '<',
          gt: '>',
          apos: "'",
          amp: '&',
          ldquo: '“',
          rdquo: '”'
        };
        var r = entity[b];
        return typeof r === 'string' ? r : matchStr;
      })
    },
    parseTimes(t){
      return t ? t.substring(5, 16) : ''
    }
  },
  data () {
    return {
      newslist: [],
      imgurl:'',
      matchingdata: {
        loseAvg: 0,
        monthAvg: 0,
        percentage: 0
      }
      // Urls:'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=d2800d18-63b2-4f18-a68a-a9c843ffa564&accessToken=97f5ca28a662be4c872c1143ecf82903&dd_orientation=auto'
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  computed:{
  },
  mounted () {
    let $this = this
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
    setTimeout(function () {
      $this.drawbarchart()
      $this.getdata()
    },500)
  },
  methods:{
    getdata(){
      const $this=this
      const url = '/api-portal/prosperity/indexOne';
      this.$api.get(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          this.matchingdata=datas.data
        }
      })
      const url2 = '/api-portal/article/articleList';
      this.$api.post(url2, {pageNum:1,pageSize:5,paramType:1}, (response) => {
        let datas=response.data||''
        if(datas&&datas.code=='000000'){
          this.newslist=datas.data.records
          if(this.newslist[0].url){
            this.imgurl=((this.newslist[0].url).split(','))[0]
          }else {
            this.imgurl=require('../../assets/default-img.jpg')
          }
        }
      },'json')
      const url3 = '/api-portal/prosperity/indexLoad';
      this.$api.post(url3, {}, (response) => {
        let datas=response.data.data||''
        if(datas){
          let datatime=[]
          let datafh=[]
          datas.map(val=>{
            const time=val.thisMonth
            const dta=val.monthAvg
            if(datatime.indexOf(time)<0){
              datatime.push(time)
              datafh.push(dta)
            }
          })
          this.drawbarchart(datatime,datafh)
        }
      })
      const url4 = '/api-portal/prosperity/indexPrice';
      this.$api.post(url4, {}, (response) => {
        let datas=response.data.data||''
        if(datas){
          let datatime=[]
          let datajg=[]
          datas.map(val=>{
            const time=val.thisMonth
            const dta=val.monthAvg
            if(datatime.indexOf(time)<0){
              datatime.push(time)
              datajg.push(dta)
            }
          })
          this.drawlinediagram(datatime,datajg)
        }
      })
      const url5 = '/api-portal/prosperity/indexList';
      this.$api.post(url5, {pageNum:1,pageSize:15}, (response) => {
        let datas=response.data.data||''
        if(datas){
          const dadatas=datas.records||[]
          let datatime=[]
          let datajqzs=[]
          dadatas.map(val=>{
            const time=val.thisMonth
            const dta=val.monthAvg
            if(datatime.indexOf(time)<0){
              datatime.push(time)
              datajqzs.push(dta)
            }
          })
          this.drawbarchart3(datatime,datajqzs)
        }
      },'json')
      const url6 = '/api-portal/prosperity/macroIndex';
      this.$api.post(url6, {}, (response) => {
        let datas=response.data.data||''
        if(datas){
          let datatime=[]
          let datahg1=[]
          let datahg2=[]
          let datahg3=[]
          let datahg4=[]
          const datass=Object.entries(datas)
          datass.map(val=>{
            const time=val[0]
            const dta=val[1]
            const pd=$this.processingdata(dta)
            datatime.push(time)
            datahg1.push(pd[0])
            datahg2.push(pd[1])
            datahg3.push(pd[2])
            datahg4.push(pd[3])
          })
          this.drawbarchart2(datatime,datahg1,datahg2,datahg3,datahg4)
        }
      })
      const url7 = '/api-portal/prosperity/turnOn';
      this.$api.post(url7, {}, (response) => {
        let datas=response.data.data||''
        if(datas){
          let datatime=[]
          let datajt=[]
          datas.map(val=>{
            const time=val.thisMonth
            const dta=val.monthAvg
            if(datatime.indexOf(time)<0){
              datatime.push(parseTime(time, '{y}-{m}-{d}'))
              datajt.push(dta)
            }
          })
          this.drawlinediagram2(datatime,datajt)
        }
      })
    },
    processingdata(data){
      let tt=new Array(4).fill('') //1-4分别存入
      if(data){
        data.map(val=>{
          const id=val.customID||''
          const vals=val.monthAvg||''
          switch (id) {
            case 5000007: //棉纱线:进口金额:当月值
              tt.splice(0,1,vals)
              break;
            case 5000008: //(停)棉纱线:出口金额:当月值
              tt.splice(1,1,vals)
              break;
            case 5000009: //(停)织物制服装:出口金额:当月值
              tt.splice(2,1,vals)
              break;
            case 5000010: //服装及衣着附件:进口金额:当月值
              tt.splice(3,1,vals)
              break;
          }
        })
      }
      return tt
    },
    drawbarchart (time,data1) {
      const myEchartst = this.$echarts.init(document.getElementById('machartbar'))
      let option = {
        tooltip: {
          show:false
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: time
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#C1D3F4'
          },
          min:val=>{
            return Math.ceil(val.min-10)>0? Math.ceil(val.min-10):val.min
          },
          splitLine:{
            show:false
          }
        },
        series: [
          {
            name: '综合负荷',
            type: 'bar',
            data: data1,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#02F0E8'
                  }, {
                    offset: 1,
                    color: '#8F41E9'
                  }
                ]
              }
            }
          }
        ]
      }
      this.loading5 = false
      myEchartst.setOption(option)
    },
    drawbarchart2 (time,data1,data2,data3,data4) {
      const myEchartst = this.$echarts.init(document.getElementById('machartbar2'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data} ${idx%2==1?'%':'亿美元'}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        color:['#13C420','#FF9933','#3333FF','#9933FF'],
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: time
        },
        yAxis: [{
          type: 'value',
          name:'亿美元',
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,-40]
          },
          axisLabel: {
            color: '#C1D3F4',
            formatter: function (params) {
              return parseInt(params)
            }
          },
          min:val=>{
            return parseInt(val.min<50?val.min:val.min-50)
          },
          splitLine:{
            show:false
          }
        },{
          type: 'value',
          name:'%',
          axisLabel: {
            color: '#C1D3F4',
          },
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,35]
          },
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          }
        }],
        series: [
          {
            name: '纺织品出口',
            type: 'bar',
            stack: 'total',
            yAxisIndex:0,
            // label: {
            //   show: true
            // },
            emphasis: {
              focus: 'series'
            },
            data: data1
          },
          {
            name: '纺织品同比',
            type: 'line',
            yAxisIndex:1,
            lineStyle: {
              color: '#3333FF'
            },
            color: '#3333FF',
            data: data2
          },
          {
            name: '服装出口',
            type: 'bar',
            stack: 'total',
            yAxisIndex:0,
            // label: {
            //   show: true
            // },
            emphasis: {
              focus: 'series'
            },
            data: data3
          },
          {
            name: '服装同比',
            type: 'line',
            yAxisIndex:1,
            lineStyle: {
              color: '#9933FF'
            },
            color: '#9933FF',
            data: data4
          }
        ]
      }
      this.loading5 = false
      myEchartst.setOption(option)
    },
    drawbarchart3 (time,data1) {
      const myEchartst = this.$echarts.init(document.getElementById('machartbar3'))
      let option = {
        tooltip: {
          show: false
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '2%',
          top: '3%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'value',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          splitLine:{
            show:false
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          min:val=>{
            return Math.ceil(val.min-10)>0? Math.ceil(val.min-10):val.min
          }
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            color: '#C1D3F4'
          },
          data: time
        },
        series: [
          {
            name: '景气指数',
            type: 'bar',
            data: data1,
            itemStyle: {
              color: {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#F0C31D'
                  }, {
                    offset: 1,
                    color: '#FE0A01'
                  }
                ]
              }
            }
          }
        ]
      }
      this.loading5 = false
      myEchartst.setOption(option)
    },
    drawlinediagram (data1,data2) {
      const myEchartst = this.$echarts.init(document.getElementById('machartline'))
      let option = {

        tooltip: {
          show: false
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '16%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data1
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          min:val=>{
            return parseInt(val.min/1000)*1000
          },
        },
        series: [{
          name: '综合价格',
          type: 'line',
          smooth: true,
          data: data2,
          showSymbol: false,
          lineStyle: {
            color: '#9933FF'
          },
          areaStyle: {
            opacity: 0.8,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#9933FF'
              },
              {
                offset: 1,
                color: '#FF33FF'
              }
            ])
          }
        }
        ]
      }
      myEchartst.setOption(option)
    },
    drawlinediagram2 (data1,data2) {
      const myEchartst = this.$echarts.init(document.getElementById('machartline2'))
      let option = {

        tooltip: {
          show: false
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '16%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data1
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          min:val=>{
            return parseInt(val.min/10)*10
          },
        },
        series: [{
          name: '江浙加弹开工率',
          type: 'line',
          smooth: true,
          data: data2,
          showSymbol:false,
          lineStyle: {
            color: '#37FFA6'
          },
          markLine: {
            data: [{ type: 'average', name: 'Avg',label: {
                formatter: "平均值{c}%",
                fontSize: "16",
                // color:'#FCCF1B',
                fontWeight:'bold'
              }}],
            label:{
              position:"middle", //标线位置，start，middle，end
            },
            lineStyle:{
              color:'#FCCF1B'
            }
          },
          areaStyle: {
            opacity: 0.8,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#37FFA6'
              },
              {
                offset: 1,
                color: '#02D2EC'
              }
            ])
          }
        }
        ]
      }
      myEchartst.setOption(option)
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: url("../../assets/secondary/bg-1.jpg");
  /*filter:contrast(120%) brightness(120%) hue-rotate(358deg) saturate(90%); !*对比度 亮度 色相旋转 饱和度*!*/
}

.secondary-content{
  width: 100%;
  height: 100%;
  padding: 0 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.matching-l{
  width: 405px;
  height: 777px;
  margin-right: -50px;
  background: url("../../assets/secondary/border-2l.png") no-repeat center/100%;
}

.matching-c{
  width: 1075px;
  height: 724px;
  padding-top: 20px;
  background: url("../../assets/secondary/center-bg.png") no-repeat center/100%;
  margin-top: 170px;
}

.matching-r{
  width: 405px;
  height: 777px;
  margin-left: -40px;
  background: url("../../assets/secondary/border-2r.png") no-repeat center/100%;
}

.matching-c-l{
  width: 350px;
  height: 620px;
  float: left;
  margin-left: 95px;
}

.matching-c-r{
  float: left;
  width: 500px;
  margin-left: 50px;
}

.matching-c-r-t{
  width: 100%;
  height: 260px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.matching-c-r-b{
  width: 500px;
  height: 280px;
  background: url("../../assets/secondary/news-bg.jpg") no-repeat center/100%;
  padding: 8px;
  box-sizing: border-box;
}

.first-news{
  display: flex;
  justify-content: space-between;
  padding: 12px 14px;
}

.first-news span{
  width: 290px;
}

.first-news a{
  font-size: 20px;
  color: #333;
  display: inline-block;
  max-width: 264px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 5px;
  text-decoration: none;
}

.first-news a:hover{
  text-decoration: underline;
}

.first-news p{
  font-size: 15px;
  color: #868686;
  width: 100%;
  line-height: 150%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space:normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-all;
  -webkit-line-clamp: 3;
}

.icon-VIP{
  display: inline-block;
  vertical-align: super;
  font-size: 21px;
  background-image: -webkit-gradient(linear, left 0, right 0, from(#DEC89D), to(#A68557));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.matching-c-r-b ul{
  border: 1px dashed #DCDDDE;
  margin: -2px 14px 12px 14px;
  padding: 5px 8px 3px 8px;
}

.matching-c-r-b ul i{
  font-style: normal;
  color: #9D9C9C;
  margin-right: 4px;
}

.matching-c-r-b ul p{
  display: inline-block;
  vertical-align: middle;
  padding: 0;
  margin: 3px 0;
  width: 334px;
  height: 24px;
}

.matching-c-r-b ul a{
  font-size: 16px;
  display: inline-block;
  vertical-align: super;
  color: #333;
  max-width: 304px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
}

.matching-c-r-b ul a:hover{
  text-decoration: underline;
}

.matching-c-r-b ul span{
  color: #999;
}

.shell{
  width: 380px;
  height: 648px;
  margin-left: 2px;
  color: #fff;
  margin-right: 15px;
  margin-top: 98px;
  transform:perspective(25em) rotatey(-6deg);
}

.shell h3,.matching-c h3{
  padding-top: 12px;
  padding-left: 6px;
  color: #BED1F8;
}

.matching-l .shell{
  margin-left: 20px;
  margin-right: 13px;
  height: 658px;
  transform:perspective(2.1em) rotatey(0.55deg);
}

.month-prosperity{
  box-sizing: border-box;
  color: #fff;
  margin-top: 25px;
}

.month-prosperity>div{
  width: 205px;
  height: 141px;
  padding: 21px 18px;
  box-sizing: border-box;
  border-radius: 5px;
  background: url("../../assets/secondary/bg-2.png") no-repeat center/100%;
}

.month-prosperity h3{
  font-size: 23px;
  font-weight: normal;
  text-shadow: 4px 3px 6px rgba(0,0,0,.4);
  padding-top: 5px;
  margin-bottom: 20px;
  color: #fff;
  font-family: 'fzskjt';
}

.month-prosperity p{
  display: flex;
  justify-content: space-between;
}

.month-prosperity b{
  font-size: 46px;
  font-family: Bahnschrift;
  text-shadow: 4px 3px 7px rgba(0,0,0,.4);
}

.month-prosperity i{
  display: block;
  font-style: normal;
  font-family: Bahnschrift;
  font-size: 17px;
  text-align: right;
  text-shadow: 1px 2px 2px rgba(0,0,0,.4);
}

div.fall{
  background: url("../../assets/secondary/bg-3.png") no-repeat center/100%;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/index-prosperity.vue